import React, { useEffect, useState } from 'react';
import { connect, useSelector } from 'react-redux';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { getArtisanAllOrders } from '../../redux/actions/OrderActions';
import Loader from '../../components/Loader';
import Message from '../../components/Message';
import NavbarTwo from '../../components/navbar/NavbarTwo';

const ArtisanOrderDetailsScreen = ({ artisanOrderList, getArtisanAllOrders }) => {

    const { id } = useParams()
    const navigate = useNavigate()

   
    const authLogin = useSelector((state) => state.authLogin)
    const { info } = authLogin;

    const auth = useSelector((state) => state.auth)
    const { authInfo } = auth;


    const { loading, artisanOrderLists, error } = artisanOrderList;


    useEffect(() => {

        if (!info) {
            navigate('/login')
        }

        getArtisanAllOrders()
    }, [getArtisanAllOrders, info, navigate ])

    const addDecimals = (num) => {
        return (Math.round(num * 100) / 100).toFixed(2)
    }

    
    return (
        <div className='bg-gray-50 min-h-screen'>
            <NavbarTwo />
            <div className='my-5'>
                <div className='container max-w-screen-xl mx-auto  px-4 md:px-2 '>
                    
                    <Link to='/artisan/orderList' className='px-5 py-3 bg-gray-200 hover:bg-gray-300 rounded text-md font-medium tracking-wider'> Home</Link>

                    {
                        loading ? <Loader /> : error ? <Message error msg={error} /> : (
                            <>
                                <h2 className='mb-16 mt-10 text-xl font-extrabold mont-font tracking-wider uppercase text-center'>order <span className='text-2xl font-extrabold'>{artisanOrderLists[id] && artisanOrderLists[id]._id}</span> </h2>
                                <div className='flex justify-between flex-col md:flex-row sen-font'>
                                    <div className='w-full md:mr-5'>
                                        <div className='mb-5 text-md'>
                                            <h2 className='mb-3 mont-font text-xl uppercase font-bold ]'>Person Details</h2>
                                            <p>
                                                <span className='font-semibold'>Name: </span>
                                                <span className='capitalize'>{artisanOrderLists[id]?.user ? artisanOrderLists[id]?.user?.name : '--'}</span>
                                            </p>
                                            <p className='my-1'>
                                                <span className='font-semibold'>Email: </span>
                                                <span className=''>{artisanOrderLists[id]?.user ? artisanOrderLists[id]?.user?.email : '--'}</span>
                                            </p>
                                            <p>
                                                <span className='font-semibold'>Phone: </span>
                                                <span className='capitalize'>{artisanOrderLists[id]?.user ? artisanOrderLists[id]?.user?.phone : '--'}</span>
                                            </p>
                                        </div>
                                        <hr className='my-5' />
                                        <div className='mb-5 text-md'>
                                            <h2 className='mb-3 mont-font text-lg uppercase font-bold'>shipping address</h2>
                                            <p className='mb-1'>
                                                <span className='font-semibold'>Address: </span>
                                                <span className='capitalize'>{artisanOrderLists[id] && artisanOrderLists[id].shippingAddress.address}</span>
                                            </p>
                                            <p className='mb-1'>
                                                <span className='font-semibold'>City: </span>
                                                <span className='capitalize'>{artisanOrderLists[id] && artisanOrderLists[id].shippingAddress.city}</span>
                                            </p>
                                            <p className='mb-1'>
                                                <span className='font-semibold'>Landmark: </span>
                                                <span className='capitalize'>{artisanOrderLists[id] && artisanOrderLists[id].shippingAddress.landmark}</span>
                                            </p>
                                            <p className='mb-1'>
                                                <span className='font-semibold'>Postal Code: </span>
                                                <span className='capitalize'>{artisanOrderLists[id] && artisanOrderLists[id].shippingAddress.postalCode}</span>
                                            </p>
                                            <p className='mb-1'>
                                                <span className='font-semibold'>Country: </span>
                                                <span className='capitalize'>{artisanOrderLists[id] && artisanOrderLists[id].shippingAddress.country}</span>
                                            </p>
                                        </div>
                                        {artisanOrderLists[id] && artisanOrderLists[id]?.isDelivered ? (
                                            <Message success msg={`Delivered on ${artisanOrderLists[id]?.deliveredAt}`} />
                                        ) : (
                                            <div className="p-3 my-4 text-md my-2 text-red-700 bg-red-100 rounded" role="alert">
                                                <span className="font-medium ">Not Delivered</span>
                                            </div>
                                        )}
                                        <hr className='my-5' />

                                        <div className='text-md'>
                                            <h2 className='mb-3 mont-font text-lg uppercase font-bold'>Payment Method</h2>
                                            <span className='font-semibold '>Method: </span>
                                            <span className='capitalize '>{artisanOrderLists[id] && artisanOrderLists[id]?.paymentMethod}</span>
                                        </div>
                                        {artisanOrderLists[id] && artisanOrderLists[id]?.isPaid ? (
                                            <Message success msg={`Paid on ${artisanOrderLists[id]?.paidAt}`} />
                                        ) : (
                                            <div className="p-3 my-4 text-md my-2 text-red-700 bg-red-100 rounded" role="alert">
                                                <span className="font-medium ">Not Paid</span>
                                            </div>
                                        )}
                                        <hr className='my-5' />
                                        <div>
                                            <h2 className='mb-3 mont-font text-xl uppercase font-bold'>Order Items</h2>
                                           
                                            <div className='mb-4 shadow p-4 rounded bg-white'>
                                                <div className='flex lg:flex-row flex-col lg:items-center'>
                                                    <div className='w-20'>
                                                        <img src={artisanOrderLists[id]?.orderItems?.image} alt={artisanOrderLists[id]?.orderItems?.name} className='w-20' />
                                                    </div>
                                                    <div className='lg:w-96 lg:mx-5 lg:my-0 my-4 w-full'>
                                                        <Link to={`/artisan/product/view/${artisanOrderLists[id]?.orderItems?.product}`} className='underline text-slate-500 mont-font'>{artisanOrderLists[id]?.orderItems?.name}</Link>
                                                    </div>

                                                    <div className='text-slate-500 sen-font'>{artisanOrderLists[id]?.orderItems?.qty} x ₹{artisanOrderLists[id]?.orderItems?.price} = <span className='text-black font-medium'>₹{artisanOrderLists[id]?.orderItems?.qty * artisanOrderLists[id]?.orderItems?.price}</span></div>
                                                </div>
                                            </div>

                                        </div>
                                    </div>
                                    <div className='w-full md:w-1/2 my-0 mx-auto md:ml-5'>
                                        <div className='border-2 text-md'>
                                            <h2 className='p-3 border-b-2 mont-font text-xl uppercase font-bold'>Order Summary</h2>
                                            <div className='flex p-3 justify-between items-center border-b-2' >
                                                <div className=''>Items</div>
                                                <div className='sen-font'>₹{addDecimals(artisanOrderLists[id]?.orderItems?.price * artisanOrderLists[id]?.orderItems?.qty)}</div>
                                            </div>
                                            <div className='flex p-3 justify-between items-center border-b-2' >
                                                <div className=''>Shipping</div>
                                                <div className='sen-font'>₹{addDecimals(artisanOrderLists[id]?.orderItems?.price * artisanOrderLists[id]?.orderItems?.qty > 100 ? 0 : 100)}</div>
                                            </div>
                                            <div className='flex p-3 justify-between items-center border-b-2' >
                                                <div className=''>Tax</div>
                                                <div className='sen-font'>₹{addDecimals(Number((artisanOrderLists[id]?.orderItems?.price * artisanOrderLists[id]?.orderItems?.qty / 100) * 5).toFixed(2))}</div>
                                                {/* <div className='sen-font'>₹{artisanOrderLists[id] && artisanOrderLists[id]?.taxPrice}</div> */}
                                            </div>
                                            <div className='flex p-3 justify-between items-center border-b-2' >
                                                <div className=''>Total</div>
                                                <div className='sen-font'>₹
                                                    {
                                                        Number(addDecimals(artisanOrderLists[id]?.orderItems?.price * artisanOrderLists[id]?.orderItems?.qty))
                                                        +
                                                        Number(addDecimals(artisanOrderLists[id]?.orderItems?.price * artisanOrderLists[id]?.orderItems?.qty > 100 ? 0 : 100))
                                                        +
                                                        Number(addDecimals((artisanOrderLists[id]?.orderItems?.price * artisanOrderLists[id]?.orderItems?.qty / 100) * 5))
                                                    }
                                                </div>
                                            </div>
                                            
                                            {/* {authInfo &&
                                                authInfo.role === 'artisan' &&
                                                artisanOrderLists[id]?.isPaid &&
                                                !artisanOrderLists[id]?.isDelivered && (
                                                    <div className='p-3'>
                                                        <button
                                                            className='uppercase text-sm tracking-wide bg-black sen-font w-full p-3 text-white disabled:hidden'
                                                        
                                                        >
                                                            Mark as Delivered</button>
                                                    </div>
                                                )
                                            } */}
                                        </div>
                                    </div>
                                </div> 

                            </>
                        )
                    }
                </div>
            </div>
        </div>
    )
}

const mapStateToProps = (state) => ({
    artisanOrderList: state.artisanOrderList
})

export default connect(mapStateToProps, { getArtisanAllOrders })(ArtisanOrderDetailsScreen);